import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-common-singup-popup',
  templateUrl: './common-singup-popup.component.html',
  styleUrls: ['./common-singup-popup.component.scss']
})
export class CommonSingupPopupComponent {
  roles = [
    {
      title: 'Driver',
      image: '../../assets/images/driver-signup.png',
      route: '/driver/registration',
      hasLine: false,
    },
    {
      title: 'Group Operator',
      image: '../../assets/images/driver-group-booking.png',
      route: '/group-operator/registration',
      hasLine: true,
    },
    {
      title: 'Parking Admin',
      image: '../../assets/images/parking-admin.png',
      route: '/onboarding',
      hasLine: false,
    },
  ];

  constructor(
    readonly ref: DynamicDialogRef,
    readonly router: Router,
  ) { }

  close() {
    this.ref.close()
  }

  routeClick(data: string) {
    this.router.navigate([data]);
    this.close();
  }
}
